// extracted by mini-css-extract-plugin
export var active = "_k2-e";
export var blink = "_k2-f";
export var dropDownSelector = "_k2-5";
export var dropDownWrapper = "_k2-4";
export var fakeCursor = "_k2-d";
export var fontSizeButton = "_k2-7";
export var formQuillEditor = "_k2-0";
export var pressed = "_k2-g";
export var qlBlank = "_k2-1";
export var textFormattingToolbar = "_k2-2";
export var textFormattingToolbarClosed = "_k2-3";
export var textFormattingToolbarInline = "_k2-6";
export var textToolbarOption = "_k2-8";
export var toolbarCell = "_k2-a";
export var toolbarCellCollapsed = "_k2-b";
export var toolbarOptionHitArea = "_k2-c";
export var toolbarOverflow = "_k2-9";